import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ColumnChartOne } from "../../../../Constant";
import { COLUMN_CHART_1_DATA, COLUMN_CHART_1_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const ColumnChart1 = () => {
  return <Col sm="12" xl="6" className="box-col-6">
  <Card>
    <CommonCardHeader title={ColumnChartOne} />
    <CardBody className="chart-block">
      <div className="chart-overflow" id="column-chart1">
        <Chart chartType="Bar" width="100%" height="400px" data={COLUMN_CHART_1_DATA} options={COLUMN_CHART_1_OPTION} />
      </div>
    </CardBody>
  </Card>
</Col>
};

export default ColumnChart1;
